import React, { useRef } from 'react';
import withQnA from '@catalogo/service-americanas-product/src/questions-and-answers/hoc/qna';
import AccordionBox from '@catalogo/ui-americanas-mobile-accordion-box-new';
import { CustomerQuestion } from '@catalogo/ui-americanas-mobile-qna/src/components/organisms/CustomerQuestion';
import QuestionsAndAnswersList from '@catalogo/ui-americanas-mobile-qna/src/components/template/ContainerQuestions';
import { HasNoQuestions } from '@catalogo/ui-americanas-mobile-qna/src/components/molecules/HasNoQuestions';
import { ButtonQuestion } from '../../molecules/ButtonQuestion';
import { WrapperBox, Content, ThemeWrapper, LeftWrapper } from './styled';
import { IQnA } from '../../../types';

// eslint-disable-next-line max-lines-per-function
export const TemplateQnA = ({
  questionsAndAnswers,
  hasCustomerQuestions,
  hasQuestions,
  fetchMore,
  productId,
  loading,
  hasOffers,
  brandText,
  clientQuestion,
  product,
  config,
  dispatchMetrics,
}: IQnA) => {
  const ref = useRef(null);

  if (!hasQuestions) {
    return (
      <ThemeWrapper>
        <AccordionBox
          ref={ref}
          title="Dúvidas sobre o produto"
          shouldGetElementHeightOnRender={false}
          visibilityOnInit={true}
          metricId="q&a"
          id="qna-wrapper"
          anchorRef="#qna-wrapper"
        >
          <HasNoQuestions productId={productId} product={product} config={config} dispatchMetrics={dispatchMetrics} />
        </AccordionBox>
      </ThemeWrapper>
    );
  }

  return (
    <ThemeWrapper>
      <AccordionBox
        ref={ref}
        title="Dúvidas sobre o produto"
        shouldGetElementHeightOnRender={false}
        visibilityOnInit={true}
        metricId="q&a"
        id="qna-wrapper"
        anchorRef="#qna-wrapper"
      >
        {!questionsAndAnswers ? (
          <></>
        ) : (
          <WrapperBox>
            <LeftWrapper>
              <ButtonQuestion hasQuestions={hasQuestions} productId={productId} key={productId} />
            </LeftWrapper>
            <Content>
              <CustomerQuestion
                isDesk={true}
                customerQuestions={clientQuestion}
                hasCustomerQuestions={hasCustomerQuestions}
              />
              <QuestionsAndAnswersList
                isDesk={true}
                brandText={brandText}
                questionsAndAnswers={questionsAndAnswers}
                fetchMore={fetchMore}
                productId={productId}
                loading={loading}
                hasOffers={hasOffers}
                product={product}
                config={config}
                dispatchMetrics={dispatchMetrics}
              />
            </Content>
          </WrapperBox>
        )}
      </AccordionBox>
    </ThemeWrapper>
  );
};

export default withQnA(TemplateQnA);
